export default "__VITE_ASSET__BrMt_v9M__"